import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { TagBloc } from '@kbloc';
import { WorkbookBloc } from '@kp/workbook/workbook.bloc';
import { Status } from '@ktypes/models';
import { Observable, combineLatest } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class WorkbookGuard {
  constructor(private _router: Router, private _tagBloc: TagBloc, private _workbookBloc: WorkbookBloc) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    if (!this._workbookBloc.workbookOrderStatus) {
      this._workbookBloc.checkWorkbookOrder();
    }
    return combineLatest([this._tagBloc.workbookEligible$, this._workbookBloc.workbookOrderStatus$]).pipe(
      skipWhile(([workbookEligible, workbookOrderStatus]) => {
        return ![Status.done, Status.error].includes(workbookOrderStatus.status);
      }),
      map(([workbookEligible, workbookOrderStatus]) => {
        if (!workbookEligible) {
          return true;
        }
        if (workbookOrderStatus.status === Status.error) {
          return true;
        }
        return (
          workbookOrderStatus.data?.requested ||
          workbookOrderStatus.data?.declined ||
          this._router.parseUrl(`/welcome/workbook`)
        );
      })
    );
  }
}
